import React, { useEffect, useState } from 'react';
import GalleryHero from '../components/gallerypage/Hero';
import GalleryCategories from '../components/gallerypage/GalleryCategories';
import PhotoGallery from '../components/gallerypage/PhotoGallery';
import VideoGallery from '../components/gallerypage/VideoGallery';
import GalleryCTA from '../components/gallerypage/GalleryCTA';

const GalleryPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  const [activeCategory, setActiveCategory] = useState('all');

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* <GalleryHero /> */}
      <GalleryCategories onCategoryChange={handleCategoryChange} />
      <PhotoGallery activeCategory={activeCategory} />
      {/* <VideoGallery /> */}
      {/* <GalleryCTA /> */}
    </div>
  );
};

export default GalleryPage;